import { ActionIcon } from '@mantine/core'
import { forwardRef } from 'react'
import { sendSignal } from '@shared/port-send-v1.0.0'
import type { Props } from '../node/definition'
import IconSvg from '@packages/icon-svg'

export default forwardRef((p: Props) => {
	return (
		<ActionIcon
			onClick={(e) => {
				e.stopPropagation()
				sendSignal(p.noodlNode, 'clicked')
			}}
			{...p}
			{...p.customProps}
		>
			<IconSvg
				iconName={p.iconName}
				iconStroke={p.iconStroke}
				iconColor={p.iconColor}
				iconSize={p.iconSize}
			/>
		</ActionIcon>
	)
})
